import React from 'react';

const { Consumer, Provider } = React.createContext();

export {
  Provider as SSRProvider,
  Consumer as SSRConsumer
}
